import React from 'react'
import './scale.scss';

const Scale = () => {
  return (
   <>
   <section className='scale_main'>
    <div className='inner_scale'>
        <img src='\assets\scale_shade.png' className='scalees'/>
        <h2> <span>Scale Your Web3 Project</span> Without the Headaches</h2>
        <p>Scale your Web3 project without the headaches. Aqua takes care of multichain deposits, swaps, and withdrawals behind the scenes, so your users enjoy a seamless experience while you focus on building and growing your dApp.</p>
        <button>Get Started with Aqua</button>
    </div>
   </section>
   </>
  )
}

export default Scale
